export const normalizeTemplateVersionItem = (item) => ({
	templateVersion: item.templateVersion ?? item.TemplateVersion,
	creationDate: item.creationDate ?? item.CreationDate,
	modificationDate: item.modificationDate ?? item.ModificationDate,
	isCurrentVersion: item.isCurrentVersion ?? item.IsCurrentVersion,
});

export const normalizeBespokeDescription = (data) => {
	if (!data) {
		return data;
	}

	const normalized = {
		...data,
		isCurrentVersion: data.isCurrentVersion ?? data.IsCurrentVersion,
	};
	delete normalized.IsCurrentVersion;
	return normalized;
};

export const sortTemplateVersions = (versions) => {
	return [...versions].sort((a, b) => {
		const [aMajor, aMinor] = String(a.templateVersion).split('.').map(Number);
		const [bMajor, bMinor] = String(b.templateVersion).split('.').map(Number);
		if (aMajor !== bMajor) {
			return bMajor - aMajor;
		}
		return bMinor - aMinor;
	});
};

export const templateVersionExists = (versions, versionLabel) => {
	return versions.some(
		(version) => String(version.templateVersion) === String(versionLabel)
	);
};

export const getCurrentTemplateVersion = (versions) => {
	return versions.find((version) => version.isCurrentVersion)?.templateVersion ?? null;
};

export const getVersionIsCurrent = (versions, templateVersion) => {
	if (templateVersion == null || versions.length === 0) {
		return null;
	}

	const version = versions.find(
		(item) => String(item.templateVersion) === String(templateVersion)
	);
	return version?.isCurrentVersion ?? null;
};
